export const ZVA_MINUTES_PLAN_CODE_DELIMITER = '$';

/**
 * Build a decorated plan code for ZVA prepaid minute tiers.
 * This is the same pattern as EVENT_SAAS PPA (basePlanCode + delimiter + quantity).
 *
 * @param {string} planCode Base plan code
 * @param {number} minutes Prepaid minutes
 * @returns {string}
 */
export const getZvaMinutesCode = (planCode, minutes) => `${planCode}${ZVA_MINUTES_PLAN_CODE_DELIMITER}${minutes}`;

/**
 * Parse a decorated plan code back to base plan code and minutes.
 *
 * @param {string} decoratedPlanCode Decorated plan code like "<base>$<minutes>"
 * @returns {{ plan_code: string, minutes: number|null }}
 */
export const parseZvaMinutesCode = (decoratedPlanCode = '') => {
  const code = (decoratedPlanCode || '').toString();
  const idx = code.lastIndexOf(ZVA_MINUTES_PLAN_CODE_DELIMITER);
  if (idx < 0) return { plan_code: code, minutes: null };

  const plan_code = code.slice(0, idx);
  const minutesStr = code.slice(idx + ZVA_MINUTES_PLAN_CODE_DELIMITER.length);
  const minutes = Number.parseInt(minutesStr, 10);
  return { plan_code, minutes: Number.isFinite(minutes) ? minutes : null };
};

